import { default as indexFUEQUYZBOtMeta } from "/app/50-ftd-20-frl-gllo/pages/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/50-ftd-20-frl-gllo/pages/index.vue")
  },
  {
    name: "index___vi",
    path: "/vi",
    component: () => import("/app/50-ftd-20-frl-gllo/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/app/50-ftd-20-frl-gllo/pages/index.vue")
  }
]